module.exports = "/_next/static/images/ph-0394a95d826151e8043531da887b6ace.svg";